import * as types from '../constants/ActionTypes'
import api from '../utils/api'

let getChatHistory = (customerEmail, companyId) => {
	var url = '/chatsByEmail/' + companyId + '/' + customerEmail

	return dispatch => {
		dispatch(getChatHistoryInitiate())
		return api(url)
			.get()
			.then(chatHistory => dispatch(getChatHistoryFinish(chatHistory)))
			.catch(err => {
				dispatch(getChatHistoryFinish({error: true}))
			})
	}
}

let getChatHistoryInitiate = () => {
	return {
		type: types.GET_CHAT_HISTORY,
		payload: {}
	}
}

let getChatHistoryFinish = (chatHistory) => {
	if (chatHistory.errCode==0) {
		return {
			type: types.GET_CHAT_HISTORY_FINISH,
			payload: {
				chatHistory:chatHistory.result
			}
		}
	} else {
		return {
			type: types.GET_CHAT_HISTORY_FINISH,
			payload: {},
			error: true
		}
	}
}

let clearChatHistory = (customerId) => {
	return dispatch => {
		dispatch(clearChatHistoryInitiate())
		dispatch(clearChatHistoryFinish(customerId))
	}
}

let clearChatHistoryInitiate = () => {
	return {
		type: types.CLEAR_CHAT_HISTORY,
		payload: {}
	}
}

let clearChatHistoryFinish = (customerId) => {
	return {
		type: types.CLEAR_CHAT_HISTORY_FINISH,
		payload: {
			customerId
		}
	}
}

let sendMediaDetails = (url, mediaType) => {
	return dispatch => {
		setupWebViewJavascriptBridge(bridge => {
			bridge.callHandler('didTapMediaIcon', {url, mediaType})
		})
	}
}

let setUnreadCount = (requestId) => {
	return {
		type: types.SET_UNREAD_COUNT,
		payload: {requestId}
	}
}

let setDashboardChatCount = () => {
	return {
		type: types.SET_DASHBOARD_CHAT_COUNT,
		payload: {}
	}
}

let setAgentChatCount = (senderFullUserId) => {
	return {
		type: types.SET_AGENT_CHAT_COUNT,
		payload: {
			senderFullUserId
		}
	}
}
let setDepartmentAgentChatCount = (senderFullUserId) => {
	return {
		type: types.SET_DEPARTMENT_AGENT_CHAT_COUNT,
		payload: {
			senderFullUserId
		}
	}
}


let updateChatCount = (chatParams) => {
	return {
		type: 'setChat',
		payload: chatParams
	}
}

export default {
	clearChatHistory,
	getChatHistory,
	sendMediaDetails,
	setUnreadCount,
	setDepartmentAgentChatCount,
	setAgentChatCount,
	setDashboardChatCount,
	updateChatCount
}
